/** Avisos rápidos no rodapé da tela. `const toast = useToast(); toast('Salvo'); toast('Atenção', 'warn');` */
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import { Icon } from './icons';

type Kind = 'ok' | 'warn';
type ToastFn = (msg: string, kind?: Kind) => void;

const ToastCtx = createContext<ToastFn | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Array<{ id: number; msg: string; kind: Kind; out: boolean }>>([]);
  const toast = useCallback<ToastFn>((msg, kind = 'ok') => {
    const id = Date.now() + Math.random();
    setItems(list => [...list.slice(-3), { id, msg, kind, out: false }]);
    window.setTimeout(() => setItems(list => list.map(t => (t.id === id ? { ...t, out: true } : t))), 3200);
    window.setTimeout(() => setItems(list => list.filter(t => t.id !== id)), 3700);
  }, []);
  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div id="toasts" role="status" aria-live="polite">
        {items.map(t => (
          <div key={t.id} className={`toast ${t.kind === 'warn' ? 'warn' : ''}${t.out ? ' out' : ''}`}>
            <Icon name={t.kind === 'warn' ? 'alert' : 'check'} />
            <span>{t.msg}</span>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast(): ToastFn {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast fora do ToastProvider');
  return ctx;
}
